/**
 * Maps a raw plan object returned by the buildable plans API to the metadata
 * shape expected by the standardCard `setMetadata()` interface.
 *
 * @param {Object} plan - Raw plan object from the API response.
 * @returns {Object} Metadata object compatible with standardCard components.
 */
const mapApiPlanToCardMetadata = (plan, markerType) => ({
  bathrooms: plan.Bathrooms,
  bedrooms: plan.Bedrooms,
  brandName: plan.BrandName,
  builderId: plan.BuilderId,
  builderRating: plan.BuilderRating,
  communityId: plan.CommunityId,
  communityName: plan.CommunityName,
  communityStatus: plan.CommunityStatus,
  city: plan.City,
  garages: plan.Garages,
  id: plan.Id,
  isAdult: plan.IsAdult || false,
  isBasic: plan.IsBasic || false,
  isMasterPlannedCommunity: plan.IsMasterPlannedCommunity || false,
  isModelHome: plan.IsModelHome || false,
  latitude: plan.Latitude,
  longitude: plan.Longitude,
  marketingStatus: plan.MarketingStatus,
  name: plan.Name || plan.PlanName || plan.Title,
  price: plan.Price,
  previousPrice: plan.Price !== plan.PreviousPrice ? plan.PreviousPrice : null,
  priceHigh: plan.PriceHigh,
  priceLow: plan.PriceLow,
  priceReduced: plan.PriceReducedText,
  squareFeet: plan.SquareFeet,
  stateAbbreviation: plan.StateAbbreviation,
  thumbnail: plan.Thumbnail,
  type: markerType,
  url: plan.Url,
  wasMatchedAsSpotlightResult: plan.WasMatchedAsSpotlightResult || false,
  zip: plan.Zip,
});

/**
 * Processes the raw buildable plans API response into an array of card metadata
 * objects ready for use with standardCard components.
 *
 * @param {Object} data - Raw API response from getBuildablePlanSummaryCardsInformation.
 * @returns {Object[]} Array of card metadata objects.
 */
const processBuildablePlansToCardMetadata = (data, markerType) => {
  const allPlans = (data?.plans ?? []).flat();

  return allPlans.map((plan) => ({
    ...mapApiPlanToCardMetadata(plan, markerType),
  }));
};

export default processBuildablePlansToCardMetadata;
